import React, { useState } from 'react';
import CommonModal from '../../Components/CommonModal';
import CommonInput from '../../Components/CommonInput';
import { domain_addition_request } from '../../services';

function AddDomainModal(props) {
    const { onHide, onSuccess } = props;
    const [resMsg, setResMsg] = useState("");
    const [msgType, setMsgType] = useState(""); // 'success' or 'error'
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        domain_name: "",
        user_justification: "",
    });

    // Validation function
    const validate = () => {
        const newErrors = {};

        if (!formData.domain_name || formData.domain_name.trim() === "") {
            newErrors.domain_name = "Domain name is required.";
        }

        if (!formData.user_justification || formData.user_justification.trim() === "") {
            newErrors.user_justification = "User justification is required.";
        } else if (formData.user_justification.trim().length < 1) {
            newErrors.user_justification = "User justification must be at least 1 character.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handle input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));
    };

    // Submit handler
    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!validate()) return;
        setLoading(true);
        setResMsg("");
        setMsgType("");

        const payload = {
            domain_name: formData.domain_name.trim(),
            user_justification: formData.user_justification.trim(),
        };

        try {
            const response = await domain_addition_request(payload);
            const responseData = response?.statusCode?.response_data;
            const errorMessage = response?.statusCode?.error?.message;

            if (errorMessage) {
                setResMsg(errorMessage);
                setMsgType("error");
            } else if (responseData) {
                const { message } = responseData;
                if (message || responseData) {
                    setResMsg(message || "Request submitted for review. The domain appears in the whitelist once approved.");
                    setMsgType("success");
                    // Close modal and refresh after showing success message
                    setTimeout(() => {
                        onHide && onHide();
                        onSuccess && onSuccess();
                    }, 1500);
                } else {
                    setResMsg(errorMessage || "Failed to add domain");
                    setMsgType("error");
                }
            } else {
                setResMsg(errorMessage || "Failed to add domain");
                setMsgType("error");
            }
        } catch (err) {
            console.error("Failed to add domain:", err);
            const errorMsg = err?.response?.data?.message || err?.message || "Failed to add domain";
            setResMsg(errorMsg);
            setMsgType("error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <CommonModal
            show={props?.show}
            onHide={onHide}
            title="Add Domain"
            buttons={[{
                text: 'Submit',
                variant: 'primary',
                onClick: handleSubmit,
                loading,
                loadingText: 'Submitting…',
                disabled: loading,
            }]}
        >
            <div className="cmn-modal-field">
                <label className="cmn-modal-label">Domain Name<span className="cmn-modal-req">*</span></label>
                <CommonInput
                    name="domain_name"
                    placeholder="Enter domain name"
                    value={formData.domain_name}
                    onChange={handleInputChange}
                    className="cmn-modal-input"
                />
                {errors.domain_name && <p className="cmn-modal-field-err">{errors.domain_name}</p>}
            </div>

            <div className="cmn-modal-field mt-3">
                <label className="cmn-modal-label">User Justification<span className="cmn-modal-req">*</span></label>
                <textarea
                    name="user_justification"
                    placeholder="Enter your justification for adding this domain"
                    value={formData.user_justification}
                    onChange={handleInputChange}
                    rows={5}
                    className="cmn-modal-input cmn-modal-textarea"
                />
                {errors.user_justification && <p className="cmn-modal-field-err">{errors.user_justification}</p>}
            </div>

            {resMsg && (
                <p className={msgType === 'success' ? 'cmn-modal-note-success mt-3' : 'cmn-modal-error'}>
                    {resMsg}
                </p>
            )}
        </CommonModal>
    );
}

export default AddDomainModal;